import MerchantSettingsDesktop from './MerchantSettingsDesktop'
import MerchantSettingsMobile from './MerchantSettingsMobile'

export default function MerchantSettingsPage() {
  return (
    <>
      <MerchantSettingsMobile />
      <MerchantSettingsDesktop />
    </>
  )
}
